export const initFaqRoutes = (config: any, enabled: boolean = true) =>
  !enabled
    ? []
    : [
      {
        path: "/manage/faq",
        name: "faq",
        component: () => import("@/pages/manage/faq/index.vue"),
        meta: {
          requiresAuth: true,
          roles: [config.roles.administrators, config.roles.siteEditors],
        },
      },
      {
        path: "/manage/faq/:id",
        name: "faq-id",
        component: () => import("@/pages/manage/faq/id.vue"),
        meta: {
          requiresAuth: true,
          roles: [config.roles.administrators, config.roles.siteEditors],
        },
      },
      {
        path: "/manage/faq/:id/new",
        name: "faq-id-new",
        component: () => import("@/pages/manage/faq/id-new.vue"),
        meta: {
          requiresAuth: true,
          roles: [config.roles.administrators, config.roles.siteEditors],
        },
      },
    ];
